import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'data/categories/actions';
import * as os from 'osutil';

class CategoryLinks extends Component {
  state = { };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.fetchCategories();
  }

  handleClick = (key, k, v) => {
    this.context.router.history.push("/admin/brand/"+this.props.brandid +"/"+key);
  }

  renderCategories = () => {
    return _.map(this.props.categories, (seg, key) => {
      return <span key={key}><a onClick={this.handleClick.bind(this, seg.key)} >{seg.name}</a></span>
    });
  }

  render() {
    return (
      <span className="CategoryList CategoryLinks">
      <em>{this.props.label}</em>
      {this.renderCategories()}
      </span>
    );
  }
}

function mapStateToProps(state, ownProps) {

  if (!state || !state.categories.list.data)
  {
    return {};
  }
  var categories = {};
  if (ownProps.categories)
    categories = os.collection_by_keys(state.categories.list.data, Object.keys(ownProps.categories));
  return {
    categories: categories
  };
}

export default connect(mapStateToProps, actions)(CategoryLinks)

  



// WEBPACK FOOTER //
// ./src/components/Lists/CategoryLinks.jsx